const stockIncreaseColor = "rgb(105, 156, 71)";
const stockDecreaseColor = "rgb(211, 44, 44)";

export { stockIncreaseColor, stockDecreaseColor };
